export default "__VITE_ASSET__D5GK1qoj__"